import { linkResolver } from 'prismic/linkResolver';
import {
  FrontpageSlicesFocal_Items,
  FrontpageSlicesFocal_ItemsDefaultItems,
} from 'prismic-types';

import { RegularOrCroppableImage } from 'components/picture/RegularOrCroppablePicture';
import { RichText, asText } from 'components/rich-text/RichText';

import { ListGrid } from '../../../components/list-grid/ListGrid';
import { PartyProfileCard } from 'components/party-profile-card/PartyProfileCard';
import { PartyFactCard } from 'components/party-fact-card/PartyFactCard';
import { generateImageSizes } from 'utils/cleverCropping';
import { useState } from 'react';
import Tabs from 'components/tabs/Tabs';
import s from './FocalItemsSlice.module.scss';
import { GridLayout, GridLayoutItem } from 'components/grid/GridLayout';
import { ListCard } from 'components/list-grid/ListCard';

type FocalItemsItem = FrontpageSlicesFocal_ItemsDefaultItems;

type Props = {
  items: Array<FocalItemsItem>;
};

export type FocalItemsSlice = FrontpageSlicesFocal_Items;

export function ListGridSlice({ items }: Props) {
  const useOldCode = true;
  // depending on the number of items we want different sizes
  const imageSizes: Record<
    string,
    { width: number; height: number } | undefined
  > = {
    '1': { width: 860, height: 631 },
    '2': { width: 860, height: 631 },
    '3': { width: 563, height: 482 },
    '4': { width: 415, height: 415 }, // not accoring to design, see: https://app.asana.com/0/1160711308714617/1203370353444930
  };

  const filteredItems = items.filter((item) => item.title && item.text);
  const imageSize =
    imageSizes[filteredItems.length.toString()] ?? imageSizes[1];
  const [activeTab, setActiveTab] = useState(0);

  const factItems = filteredItems.filter((item) =>
    asText(item.title).includes('Stuðreynd')
  );

  const otherItems = filteredItems.filter(
    (item) => !asText(item.title).includes('Stuðreynd')
  );

  return useOldCode ? (
    <ListGrid>
      {filteredItems
        .filter((item) => item.title && item.text)
        .map((item, i) => (
          <ListCard
            offset={i === 1 && filteredItems.length === 2}
            key={i}
            size={filteredItems.length}
            image={
              <RegularOrCroppableImage image={item.image} {...imageSize} />
            }
            title={asText(item.title)}
            link={item.link ? linkResolver(item.link) : undefined}
          >
            <RichText>{item.text}</RichText>
          </ListCard>
        ))}
    </ListGrid>
  ) : (
    <GridLayout>
      <GridLayoutItem offset={{ wide: 0 }}>
        <Tabs
          activeTab={activeTab}
          onTabClick={(tabId) => {
            setActiveTab(tabId);
          }}
          className={s.tabContainer}
          classNameTabs={s.tabs}
          style="medium"
          tabs={[
            {
              id: 'studreyndir',
              label: 'Stuðreyndir',
              content: (
                <ListGrid>
                  {factItems.map((item, i) => (
                    <PartyFactCard
                      key={i}
                      text={asText(item.text)}
                      title={asText(item.title)}
                      link={item.link ? linkResolver(item.link) : undefined}
                    ></PartyFactCard>
                  ))}
                  {factItems.map((item, i) => (
                    <PartyFactCard
                      key={i}
                      text={asText(item.text)}
                      title={asText(item.title)}
                      link={item.link ? linkResolver(item.link) : undefined}
                    ></PartyFactCard>
                  ))}
                </ListGrid>
              ),
            },
            {
              id: 'studprofilar',
              label: 'Stuðprófílar',
              content: (
                <ListGrid>
                  {otherItems.map((item, i) => (
                    <PartyProfileCard
                      key={i}
                      image={
                        item.image ? (
                          <RegularOrCroppableImage
                            image={item.image}
                            componentSizes={generateImageSizes({
                              ratio: 1.4,
                              wide: 900,
                            })}
                          />
                        ) : undefined
                      }
                      title={asText(item.text)}
                      link={item.link ? linkResolver(item.link) : undefined}
                    ></PartyProfileCard>
                  ))}
                  {otherItems.map((item, i) => (
                    <PartyProfileCard
                      key={i}
                      image={
                        item.image ? (
                          <RegularOrCroppableImage
                            image={item.image}
                            componentSizes={generateImageSizes({
                              ratio: 1.4,
                              wide: 900,
                            })}
                          />
                        ) : undefined
                      }
                      title={asText(item.text)}
                      link={item.link ? linkResolver(item.link) : undefined}
                    ></PartyProfileCard>
                  ))}
                </ListGrid>
              ),
            },
          ]}
        />
      </GridLayoutItem>
    </GridLayout>
  );
}

export function prismicSliceToFocalItems(s: FocalItemsSlice) {
  const items = (s.variation?.items ?? null) as Array<FocalItemsItem>;

  if (!items.length) {
    return null;
  }

  return <ListGridSlice items={items} />;
}
